import { render, staticRenderFns } from "./myresourseList.vue?vue&type=template&id=28a28c99"
import script from "./myresourseList.vue?vue&type=script&lang=js"
export * from "./myresourseList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports